import { MuiIconNames } from '@features/cms/typings/material-icon-font'

export const audioMemoConfigSchema = {
  type: 'object',
  properties: {
    icon: { type: 'string', enum: MuiIconNames }
  }
}
